import React, {memo} from 'react'
import PropTypes from 'prop-types'
import Polygon from '../Navigation/Polygon'
import { theme } from '../../styles/globalStyles'
import { Accent } from '../../styles/teamStyles'

import useWindowResize from '../../hooks/useWindowResize'

const MemberAccent = () => {
  const windowSize = useWindowResize()

  const coordsAccent = () => {
    if (windowSize.width >= 1900) {
      return {
          x: '175%',
          y: '50%',
          d: 1.75,
          r: -67,
        }
    } else if (windowSize.width >= 1680) {
      return {
        x: '155%',
        y: '50%',
        d: 1.75,
        r: -67,
      }
    } else if (windowSize.width >= 1536) {
      return {
        x: '175%',
        y: '50%',
        d: 1.75,
        r: -67,
      }
    } else if (windowSize.width >= 1440) {
      return {
        x: '153%',
        y: '50%',
        d: 1.65,
        r: -67,
      }
    } else if (windowSize.width >= 1360) {
      return {
        x: '175%',
        y: '50%',
        d: 1.65,
        r: -67,
      }
    } else if (windowSize.width >= 1280) {
      if (windowSize.width >= 1280 && windowSize.height >= 800) {
        return {
          x: '108%',
          y: '40%',
          d: 1.5,
          r: -67,
        }
      } else if (windowSize.width >= 1280 && windowSize.height < 650) {
        return {
          x: '175%',
          y: '50%',
          d: 1.65,
          r: -67,
        }
      } else if (windowSize.width >= 1280 && windowSize.height < 800) {
        return {
          x: '155%',
          y: '50%',
          d: 1.65,
          r: -67,
        }
      }
    } else if (windowSize.width > 1024 && windowSize.width < 1280) {
      return {
        x: '122%',
        y: '50%',
        d: 1.65,
        r: -67,
      }
    } else if (windowSize.width <= 1024) {
      if (windowSize.width > 420) {
        return {
          x: '72%',
          y: '20%',
          d: 1.5,
          r: -85,
        }
      } else if (windowSize.width <= 340) {
        return {
          x: '72%',
          y: '20%',
          d: 1.5,
          r: -85,
        }
      } else {
        return {
          x: '72%',
          y: '20%',
          d: 1.5,
          r: -85,
        }
      }
    }
  }

  const accentVars = {
    hidden: {
      x: '180%',
      y: '180%',
      rotate: -280,
      opacity: 0,
      scale: 0.5,
    },
    exit: {
      x: '180%',
      y: '180%',
      rotate: -280,
      opacity: 0,
      scale: 0.5,
      transition: {
        duration: 1.25,
      }
    },
    visible: {
      x: coordsAccent().x,
      y: coordsAccent().y,
      rotate: coordsAccent().r,
      opacity: 1,
      scale: coordsAccent().d,
    },
  }
  return (
    <>
      { windowSize.width > 420 && (
        <Accent
          initial='hidden'
          animate='visible'
          exit='exit'
          variants={accentVars}
          transition={{
            duration: 1.25,
            ease: 'easeOut',
          }}>
          <Polygon shape='heptagon' fill={theme.orange} />
        </Accent>
      )}
    </>
  )
}

MemberAccent.propTypes = {
  isVisible: PropTypes.bool.isRequired
}

export default memo(MemberAccent)
